<template>
                      <div class="text-main-title">
                        <button
                          type="button"
                          class="btn btn-theme button-position"
                          v-on:click="resetFields()"
                        >
                          <i class="mdi mdi-arrow-left"></i> Back
                        </button>
                        <h2 class="titleStepForm">Personal Information</h2>
                      </div>
<template v-if="!isEdit">

</template>
                      <div class="main-from-group my-4">
                        <div class="row">
                          <template v-if="isEdit">
                          <div class="col-lg-12 col-md-6 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Please Select Your Closest Eastern Credit Union
                                Branch
                              </label>
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select branch"
                                  v-model="form.personal1.branchName"
                                  :options="branchNameOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.branchName.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal1, index) in v$.form.personal1
                                    .branchName.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal1.$message">{{
                                    personal1.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          </template>
                          <div class="col-12 mb-3">
                            <div class="groupFormStyle">
                              <div class="row">
                                <template v-if="!isEdit">
                                <div class="col-12 mb-4">
                                  <label class="font-size-14"
                                    >Please Select Your Preferred Eastern Credit
                                    Union Branch
                                  </label>
                                  <div class="single-select2-cstm">
                                    <Select2
                                      v-model="form.personal1.branchName"
                                      placeholder="Choose the branch name"
                                      :options="branchNameOpt"
                                      :class="{
                                        'is-invalid':
                                          v$.form.personal1.branchName.$error,
                                      }"
                                    />
                                    <div
                                      v-for="(personal1, index) in v$.form
                                        .personal1.branchName.$errors"
                                      :key="index"
                                      class="invalid-feedback"
                                    >
                                      <span v-if="personal1.$message">{{
                                        personal1.$message
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <hr />
                                </template>
                                <div class="col-12">
                                  <h3 class="formMainHeading ea-sub ea-sub--user">Applicant Details</h3>
                                </div>
                                <div class="col-lg-3 col-md-6 mb-3">
                                  <div class="d-block">
                                    <label class="font-size-14">Title</label>
                                    <div class="single-select2-cstm">
                                      <Select2 placeholder="Select title"
                                        v-model="form.personal1.title"
                                        :options="titleNameOpt"
                                        :class="{
                                          'is-invalid':
                                            v$.form.personal1.title.$error,
                                        }"
                                      />
                                      <div
                                        v-for="(personal1, index) in v$.form
                                          .personal1.title.$errors"
                                        :key="index"
                                        class="invalid-feedback"
                                      >
                                        <span v-if="personal1.$message">{{
                                          personal1.$message
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 mb-3">
                                  <div class="d-block">
                                    <label class="font-size-14">Surname</label>
                                    <input placeholder="Enter surname"
                                      type="text"
                                      class="form-control"
                                      v-model="form.personal1.surname"
                                      :class="{
                                        'is-invalid':
                                          v$.form.personal1.surname.$error,
                                      }"
                                    />
                                    <div
                                      v-for="(personal1, index) in v$.form
                                        .personal1.surname.$errors"
                                      :key="index"
                                      class="invalid-feedback"
                                    >
                                      <span v-if="personal1.$message">{{
                                        personal1.$message
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 mb-3">
                                  <div class="d-block">
                                    <label class="font-size-14">First Name</label>
                                    <input placeholder="Enter first name"
                                      type="text"
                                      v-model="form.personal1.firstName"
                                      class="form-control"
                                      :class="{
                                        'is-invalid':
                                          v$.form.personal1.firstName.$error,
                                      }"
                                    />
                                    <div
                                      v-for="(personal1, index) in v$.form
                                        .personal1.firstName.$errors"
                                      :key="index"
                                      class="invalid-feedback"
                                    >
                                      <span v-if="personal1.$message">{{
                                        personal1.$message
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 mb-3">
                                  <div class="d-block">
                                    <label class="font-size-14"
                                      >Middle Name</label
                                    >
                                    <input placeholder="Enter middle name"
                                      type="text"
                                      v-model="form.personal1.middleName"
                                      class="form-control"
                                    />
                                    <!-- Optional validation: middleName -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <h3 class="formMainHeading ea-sub ea-sub--address">Address Information</h3>
                          </div>
                          <div class="col-lg-12 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Home Address</label>
                              <textarea placeholder="Enter home address"
                                type="textarea"
                                v-model="form.personal1.address"
                                class="form-control"
                                rows="1"
                              ></textarea>
                              <!-- Optional validation: address -->
                            </div>
                          </div>
                          <!-- Optional validation: geoCode -->
                          <!-- Optional validation: mailingAddress -->
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Address Line #1 </label>
                              <textarea placeholder="Enter address line 1"
                                type="text"
                                v-model="form.personal1.address_line"
                                class="form-control"
                                rows="1"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal1.address_line.$error,
                                }"
                              ></textarea>

                              <div
                                v-for="(personal1, index) in v$.form.personal1
                                  .address_line.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal1.$message">{{
                                  personal1.$message
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Address Line #2 </label>
                              <textarea placeholder="Enter address line 2"
                                type="text"
                                v-model="form.personal1.address_line_two"
                                class="form-control"
                                rows="1"
                              ></textarea>
                              <!-- Optional validation: address_line_two -->
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">City</label>
                              <textarea placeholder="Enter city"
                                type="text"
                                v-model="form.personal1.city_name"
                                class="form-control"
                                rows="1"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal1.city_name.$error,
                                }"
                              ></textarea>

                              <div
                                v-for="(personal1, index) in v$.form.personal1
                                  .city_name.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal1.$message">{{
                                  personal1.$message
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">State / Prov</label>
                              <textarea placeholder="Enter state / province"
                                type="text"
                                v-model="form.personal1.state_name"
                                class="form-control"
                                rows="1"
                              ></textarea>
                              <!-- Optional validation: state_name -->
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Zip Code</label>
                              <input placeholder="Enter zip code"
                                type="number"
                                v-model="form.personal1.zip_code"
                                @input="validateZipCode"
                                class="form-control"
                                rows="1"
                                inputmode="numeric"
                              />
                              <!-- Optional validation: zip_code -->
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Country</label>
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select country"
                                  v-model="form.personal1.country_name"
                                  :options="country_nameOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.country_name.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal1, index) in v$.form.personal1
                                    .country_name.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal1.$message">{{
                                    personal1.$message
                                  }}</span>
                                </div>
                              </div>
                              <!-- Optional validation: country_name -->
                            </div>
                          </div>
                          <div class="col-12">
                            <h3 class="formMainHeading ea-sub ea-sub--personal">Personal Details</h3>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Date of Birth</label>
                              <AppDatePicker v-model="form.personal1.dob" placeholder="Select date of birth" past-only :invalid="v$.form.personal1.dob.$error" />
                              <div class="invalid-feedback" v-if="isInvalidDOB"
                                >Date of Birth cannot be greater than the current
                                date.</div>
                              <div class="invalid-feedback" v-if="invalidDOBMinor"
                                >Date of birth must indicate a minor's age.</div>
                              <div class="invalid-feedback" v-if="invalidDOBadult"
                                >Date of birth must indicate an adult's
                                age.</div>
                              <div
                                v-for="(personal1, index) in v$.form.personal1.dob
                                  .$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal1.$message">{{
                                  personal1.$message
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <h4 class="font-size-14">Gender</h4>
                            <div class="row">
                              <div class="col-auto mb-2">
                                <label
                                  for="maleGender"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid': v$.form.personal1.gender.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.gender"
                                    name="genderRadio"
                                    class="inputRadioCstm d-none"
                                    id="maleGender"
                                    value="male"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Male
                                  </h4>
                                </label>
                              </div>
                              <div class="col-auto mb-2">
                                <label
                                  for="femaleGender"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid': v$.form.personal1.gender.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.gender"
                                    name="genderRadio"
                                    class="inputRadioCstm d-none"
                                    id="femaleGender"
                                    value="female"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Female
                                  </h4>
                                </label>
                              </div>

  <div v-if="v$.form.personal1.gender.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal1.gender.$errors[0]">{{ v$.form.personal1.gender.$errors[0].$message }}</span></div>
  </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >No. of Dependants</label
                              >
                              <input placeholder="Enter number of dependants"
                                type="number"
                                v-model="form.personal1.numOfDependents"
                                class="form-control"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal1.numOfDependents.$error,
                                }"
                                inputmode="numeric"
                              />
                              <div
                                v-for="(personal1, index) in v$.form.personal1
                                  .numOfDependents.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal1.$message">{{
                                  personal1.$message
                                }}</span>
                                <!-- ------------------------------------------------------------------------------------ -->
                              </div>
                              <!-- Optional form input -->
                            </div>
                          </div>
                          <div class="col-lg-6 mb-3">
                            <div class="d-block">
                              <template v-if="isEdit">
                              <label class="font-size-14">Country of Birth</label>
                              </template>
                              <template v-if="!isEdit">
                              <label class="font-size-14">Place of Birth</label>
                              </template>
                              <div class="single-select2-cstm">
                                <template v-if="isEdit">
                                <Select2 placeholder="Select place of birth"
                                  v-model="form.personal1.placeOfdob"
                                  :options="nationalityOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.placeOfdob.$error,
                                  }"
                                />
                                </template>
                                <template v-if="!isEdit">
                                <!-- Optional validation: placeOfdob -->
                                <textarea placeholder="Enter place of birth"
                                  type="text"
                                  v-model="form.personal1.placeOfdob"
                                  class="form-control"
                                  rows="1"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.placeOfdob.$error,
                                  }"
                                ></textarea>
                                </template>
                                <div
                                  v-for="(personal1, index) in v$.form.personal1
                                    .placeOfdob.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal1.$message">{{
                                    personal1.$message
                                  }}</span>
                                </div>
                              </div>
                              <template v-if="isEdit">

                              <!-- Optional validation: placeOfdob -->
                              </template>
                            </div>
                          </div>
                          <div class="col-lg-6 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Nationality</label>
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select nationality"
                                  v-model="form.personal1.nationality"
                                  :options="nationalityOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.nationality.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal1, index) in v$.form.personal1
                                    .nationality.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal1.$message">{{
                                    personal1.$message
                                  }}</span>
                                </div>
                              </div>
                              <!-- Optional validation: nationality -->
                            </div>
                          </div>
                          <div class="col-12 mb-3">
                            <h4 class="font-size-14">Marital Status</h4>
                            <div class="row">
                              <div class="col-auto mb-2">
                                <label
                                  for="singleMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="single"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="singleMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Single
                                  </h4>
                                </label>
                              </div>
                              <div class="col-auto mb-2">
                                <label
                                  for="marriedMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="married"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="marriedMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Married
                                  </h4>
                                </label>
                              </div>
                              <div class="col-auto mb-2">
                                <label
                                  for="divorcedMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="divorced"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="divorcedMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Divorced
                                  </h4>
                                </label>
                              </div>
                              <div class="col-auto mb-2">
                                <label
                                  for="widowedMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="widowed"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="widowedMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Widowed
                                  </h4>
                                </label>
                              </div>
                              <div class="col-auto mb-2">
                                <label
                                  for="separatedMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="separated"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="separatedMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Separated
                                  </h4>
                                </label>
                              </div>

                              <div class="col-auto mb-2">
                                <label
                                  for="commonLawMat"
                                  class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal1.maritalStatus.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal1.maritalStatus"
                                    value="common_low"
                                    name="materialRadio"
                                    class="inputRadioCstm d-none"
                                    id="commonLawMat"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Common Law
                                  </h4>
                                </label>
                              </div>

  <div v-if="v$.form.personal1.maritalStatus.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal1.maritalStatus.$errors[0]">{{ v$.form.personal1.maritalStatus.$errors[0].$message }}</span></div>
  </div>
                          </div>
                          <div class="col-12">
                            <h3 class="formMainHeading ea-sub ea-sub--id">Identification Details</h3>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >National Identification No.</label
                              >
                              <input placeholder="Enter national ID number"
                                type="text"
                                v-model="form.personal1.nationalIdNum"
                                class="form-control"
                                @input="validatenationalidentification"
                                inputmode="numeric"
                              />
                              <!-- Optional validation: nationalIdNum -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Issue Date</label>
                              <AppDatePicker v-model="form.personal1.nidIssueDate" placeholder="Select issue date" />
                              <div class="invalid-feedback"
                                v-if="isIssueDateInvalid"
                                >Issue Date should be in Past.</div>
                              <!-- showMessageAfterClearingdid -->
                              <div class="invalid-feedback"
                                v-if="isIssueDateFuture"
                                >Issue Date cannot be a future date.</div>
                              <!-- Optional validation: nidIssueDate -->
                              <!-- Optional UI element -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Expiry Date</label>
                              <AppDatePicker v-model="form.personal1.nidExpiry" placeholder="Select expiry date" />
                              <div class="invalid-feedback"
                                v-if="isExpiryDateInvalid"
                                >Expiry Date should be in Future.</div>
                              <!-- Optional validation: nidExpiry -->
                              <div
                                v-if="isExpiryDateInvalid"
                                class="invalid-feedback"
                              >
                                Expiry Date should be after Issue Date.
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Country of Issuance</label
                              >
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select country of issuance"
                                  v-model="form.personal1.nationalIssuance"
                                  :options="nationalIssuanceOpt"
                                />
                                <!-- Optional validation: nationalIssuance -->
                              </div>
                            </div>
                          </div>
                          <div class="col-12 ea-group-error" v-if="errorpartone">
                            <div class="invalid-feedback">
                              Please fill in at least one of the three sections.
                            </div>
                          </div>
                          <div class="col-12 ea-group-error" v-if="errorpart">
                            <div class="invalid-feedback">
                              Please fill all fields of National Identification No.
                            </div>
                          </div>

                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Driver’s Permit No.</label
                              >
                              <template v-if="isEdit">
                              <input placeholder="Enter driver permit number"
                                type="text"
                                v-model="form.personal1.drivingIdNum"
                                class="form-control"
                                maxlength="6"
                                @input="validateDrivingIdNum"
                              />
                              </template>
                              <template v-if="!isEdit">
                              <input placeholder="Enter driver permit number"
                                type="text"
                                v-model="form.personal1.drivingIdNum"
                                class="form-control"
                                maxlength="13"
                                @input="validateDrivingIdNum"
                              />
                              </template>
                              <!-- Optional validation: drivingIdNum -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Issue Date</label>
                              <AppDatePicker v-model="form.personal1.didIssueDate" placeholder="Select issue date" />
                              <div class="invalid-feedback"
                                v-if="isdidIssueDateInvalid"
                                >Issue Date should be in Past.</div>
                              <div class="invalid-feedback"
                                v-if="isdidIssueDateFuture"
                                >Issue Date cannot be a future date.</div>
                              <!-- Optional validation: didIssueDate -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Expiry Date</label>
                              <AppDatePicker v-model="form.personal1.didExpiry" placeholder="Select expiry date" />
                              <div class="invalid-feedback"
                                v-if="isdidExpiryDateInvalid"
                                >Expiry Date should be in Future.</div>
                              <!-- Optional validation: didExpiry -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Country of Issuance</label
                              >
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select country of issuance"
                                  v-model="form.personal1.driverIssuance"
                                  :options="nationalIssuanceOpt"
                                />
                                <!-- Optional validation: driverIssuance -->
                              </div>
                            </div>
                          </div>
                          <div class="col-12 ea-group-error" v-if="errorparttwo">
                            <div class="invalid-feedback">
                              If you fill in Driver’s Permit No., please fill in at
                              least one more field from National Identification No.
                              and Passport No.
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Passport No.</label>
                              <input placeholder="Enter passport number"
                                type="text"
                                v-model="form.personal1.passportNum"
                                class="form-control"
                                @input="validatepassportnumber"
                              />
                              <!-- Optional validation: passportNum -->
                              <!-- Optional form input -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Issue Date</label>
                              <AppDatePicker v-model="form.personal1.passIssueDate" placeholder="Select issue date" />
                              <div class="invalid-feedback"
                                v-if="ispassIssueDateInvalid"
                                >Issue Date should be in Past.</div>
                              <div class="invalid-feedback"
                                v-if="ispassIssueDateFuture"
                                >Issue Date cannot be a future date.</div>
                              <!-- Optional validation: passIssueDate -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14">Expiry Date</label>
                              <AppDatePicker v-model="form.personal1.passExpiry" placeholder="Select expiry date" />
                              <div class="invalid-feedback"
                                v-if="ispassExpiryDateInvalid"
                                >Expiry Date should be in Future.</div>
                              <!-- Optional validation: passExpiry -->
                            </div>
                          </div>
                          <div class="col-lg-3 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Country of Issuance</label
                              >
                              <div class="single-select2-cstm">
                                <Select2 placeholder="Select country of issuance"
                                  v-model="form.personal1.passportIssuance"
                                  :options="nationalIssuanceOpt"
                                />
                                <!-- Optional validation: passportIssuance -->
                              </div>
                            </div>
                          </div>

                          <template v-if="radioSelected1 === 'minor'">
                            <div class="col-lg-6 mb-3">
                              <div class="d-block">
                                <label class="font-size-14"
                                  >Birth Certificate PIN No.
                                  <sup>(for minors)</sup>
                                </label>
                                <input placeholder="Enter birth certificate number"
                                  type="number"
                                  v-model="form.personal1.birthIdNum"
                                  class="form-control"
                                />
                                <!-- Optional validation: birthIdNum -->
                              </div>
                            </div>
                            <div class="col-lg-6 mb-3">
                              <div class="d-block">
                                <label class="font-size-14"
                                  >Country of Issuance</label
                                >
                                <div class="single-select2-cstm">
                                  <Select2 placeholder="Select country of issuance"
                                    v-model="form.personal1.birthIssuance"
                                    :options="nationalIssuanceOpt"
                                  />
                                  <!-- Optional validation: birthIssuance -->
                                </div>
                              </div>
                            </div>
                          </template>

                          <div class="col-lg-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Area Code / Home Number</label
                              ><span>(Numbers only)</span>
                              <div class="d-flex">
                                <div
                                  class="single-select2-cstm"
                                  style="min-width: 96px;margin-right: 10px;"
                                >
                                  <Select2 placeholder="Code"
                                    v-model="form.personal1.homePhoneNumcode"
                                    :options="countrynameIssuanceOpt"
                                    :class="{
                                      'is-invalid':
                                        v$.form.personal1.homePhoneNumcode.$error,
                                    }"
                                  >
                                  </Select2>

                                  <div
                                    v-for="(personal1, index) in v$.form.personal1
                                      .homePhoneNumcode.$errors"
                                    :key="index"
                                    class="invalid-feedback"
                                  >
                                    <span v-if="personal1.$message">{{
                                      personal1.$message
                                    }}</span>
                                  </div>
                                </div>

                                <div class="d-block">
                                  <input
                                    type="number"
                                    placeholder="No dashes or spaces"
                                    v-model="form.personal1.homePhoneNum"
                                    class="form-control"
                                    inputmode="numeric"
                                    :class="{
                                      'is-invalid':
                                        v$.form.personal1.homePhoneNum.$error,
                                    }"
                                    @input="validatehomenumber"
                                  />
                                  <template v-if="isEdit">
                                  <div class="invalid-feedback"
                                    v-if="ispassIssuenumberInvalid"
                                    >Atleast 9 number required</div>
                                  </template>
                                  <template v-if="!isEdit">
                                  <div class="invalid-feedback"
                                    v-if="ispassIssuenumberInvalid"
                                    >Atleast 7 number required</div>
                                  </template>
                                  <div
                                    v-for="(personal1, index) in v$.form.personal1
                                      .homePhoneNum.$errors"
                                    :key="index"
                                    class="invalid-feedback"
                                  >
                                    <span
                                      class="d-block"
                                      v-if="personal1.$message"
                                      >{{ personal1.$message }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="d-block">
                              <label class="font-size-14"
                                >Area Code / Mobile No.</label
                              ><span>(Numbers only)</span>
                              <div class="d-flex">
                                <div
                                  class="single-select2-cstm"
                                  style="min-width: 96px;margin-right: 10px;"
                                >
                                  <template v-if="isEdit">
                                  <Select2 placeholder="Code"
                                    v-model="form.personal1.mobileNumcode"
                                    :options="countrynameIssuanceOpt"
                                    :class="{
                                      'is-invalid':
                                        v$.form.personal1.mobileNumcode.$error,
                                    }"
                                  >
                                  </Select2>
                                  </template>
                                  <template v-if="!isEdit">
                                  <Select2 placeholder="Code"
                                    v-model="form.personal1.mobileNumcode"
                                    :options="countrynameIssuanceOpt"
                                  >
                                  </Select2>
                                  </template>
                                  <template v-if="isEdit">
                                  <div
                                    v-for="(personal1, index) in v$.form.personal1
                                      .mobileNumcode.$errors"
                                    :key="index"
                                    class="invalid-feedback"
                                  >
                                    <span v-if="personal1.$message">{{
                                      personal1.$message
                                    }}</span>
                                  </div>
                                  </template>
                                  <template v-if="!isEdit">
                                  <!-- Optional validation: mobileNumcode -->
                                  </template>
                                </div>
                                <div class="d-block">
                                  <template v-if="isEdit">
                                  <input
                                    type="number"
                                    v-model="form.personal1.mobileNum"
                                    placeholder="No dashes or spaces"
                                    class="form-control"
                                    :class="{
                                      'is-invalid':
                                        v$.form.personal1.mobileNum.$error,
                                    }"
                                    @input="validatemobnumber"
                                  />
                                  </template>
                                  <template v-if="!isEdit">
                                  <input
                                    type="number"
                                    v-model="form.personal1.mobileNum"
                                    placeholder="No dashes or spaces"
                                    class="form-control"
                                    @input="validatemobnumber"
                                  />
                                  </template>
                                  <template v-if="isEdit">
                                  <div class="invalid-feedback"
                                    v-if="ispassnumberInvalid"
                                    >Atleast 9 number required</div>
                                  </template>
                                  <template v-if="!isEdit">
                                  <div class="invalid-feedback"
                                    v-if="ispassnumberInvalid"
                                    >Atleast 7 number required</div>
                                  </template>

                                  <template v-if="isEdit">
                                  <div
                                    v-for="(personal1, index) in v$.form.personal1
                                      .mobileNum.$errors"
                                    :key="index"
                                    class="invalid-feedback"
                                  >
                                    <span v-if="personal1.$message">{{
                                      personal1.$message
                                    }}</span>
                                  </div>
                                  </template>
                                  <template v-if="!isEdit">
                                  <!-- Optional validation: mobileNum -->
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="d-block">
                              <template v-if="isEdit">
                              <label class="font-size-14">Email Address</label>
                              </template>
                              <template v-if="!isEdit">
                              <label class="font-size-14"
                                >Emaifdfddl Address</label
                              >
                              </template>
                              <input placeholder="Enter email address"
                                type="email"
                                v-model="form.personal1.email"
                                class="form-control"
                                :class="{
                                  'is-invalid': v$.form.personal1.email.$error,
                                }"
                              />
                              <div
                                v-for="(personal1, index) in v$.form.personal1
                                  .email.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal1.$message">{{
                                  personal1.$message
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="uploadFileSection groupFormStyle">
                          <h2 class="formMainHeading ea-sub ea-sub--upload">Upload Documents</h2>
                          <p class="ea-sub-note">Please upload required docs (PNG)</p>
                          <div class="row">
                            <div class="col-lg-4 mb-3">
                              <div class="form-group">
                                <label for="my-file"
                                  >National Identification</label
                                >
                                <FileUploadField :name="docName('nat_identity')" :busy="docBusy" @remove="removeDoc('nat_identity')" @replace="onFileChange1"><input
                                  type="file"
                                  ref="fileInput1"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png,  "
                                  @change="onFileChange1"
                                  class="form-control"
                                  id="my-file"
                                /></FileUploadField>

                                <template v-if="preview[0]">
                                  <div class="border bg-white p-2 mt-3">
                                    <h4 class="font-size-15 mb-3">
                                      National Identification Here:
                                    </h4>
                                    <template v-if="isEdit">
                                    <img
                                      v-if="
                                        preview[0].type === 'pdf' ||
                                        preview[0].type === 'docx' ||
                                        preview[0].type === 'xlsx'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[0].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <template v-if="!isEdit">
                                    <img
                                      v-if="
                                        preview[0].type === 'pdf' ||
                                        preview[0].type === 'docx' ||
                                        preview[0].type === 'xlsx' ||
                                        preview[0].type === 'image/jpeg' ||
                                        preview[0].type === 'image/png'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[0].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <p class="mb-0">
                                      file name: {{ image[0].name }}
                                    </p>
                                    <p class="mb-0">
                                      size: {{ image[0].size / 1024 }}KB
                                    </p>
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div class="col-lg-4 mb-3">
                              <div class="form-group">
                                <label for="my-file1">Driver’s Permit</label>
                                <FileUploadField :name="docName('driver')" :busy="docBusy" @remove="removeDoc('driver')" @replace="onFileChange2"><input
                                  type="file"
                                  ref="fileInput2"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png,"
                                  @change="onFileChange2"
                                  class="form-control"
                                  id="my-file1"
                                /></FileUploadField>

                                <template v-if="preview[1]">
                                  <div class="border bg-white p-2 mt-3">
                                    <h4 class="font-size-15 mb-3">
                                      Driver’s Permit Here:
                                    </h4>
                                    <template v-if="isEdit">
                                    <img
                                      v-if="
                                        preview[1].type === 'pdf' ||
                                        preview[1].type === 'docx' ||
                                        preview[1].type === 'xlsx'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[1].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <template v-if="!isEdit">
                                    <img
                                      v-if="
                                        preview[1].type === 'pdf' ||
                                        preview[1].type === 'docx' ||
                                        preview[1].type === 'xlsx' ||
                                        preview[1].type === 'image/jpeg' ||
                                        preview[1].type === 'image/png'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[1].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <p class="mb-0">
                                      file name: {{ image[1].name }}
                                    </p>
                                    <p class="mb-0">
                                      size: {{ image[1].size / 1024 }}KB
                                    </p>
                                  </div>
                                </template>
                                <template v-if="!isEdit">
                                <!-- Section: Driver’s Permit Here: -->
                                </template>
                              </div>
                            </div>
                            <div class="col-lg-4 mb-3">
                              <div class="form-group">
                                <label for="my-file2">Passport</label>
                                <FileUploadField :name="docName('passport')" :busy="docBusy" @remove="removeDoc('passport')" @replace="onFileChange3"><input
                                  type="file"
                                  ref="fileInput3"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                                  @change="onFileChange3"
                                  class="form-control"
                                  id="my-file2"
                                /></FileUploadField>
                                <template v-if="preview[2]">
                                  <div class="border bg-white p-2 mt-3">
                                    <h4 class="font-size-15 mb-3">
                                      Passport Here:
                                    </h4>
                                    <template v-if="isEdit">
                                    <img
                                      v-if="
                                        preview[2].type === 'pdf' ||
                                        preview[2].type === 'docx' ||
                                        preview[2].type === 'xlsx'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[2].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <template v-if="!isEdit">
                                    <img
                                      v-if="
                                        preview[2].type === 'pdf' ||
                                        preview[2].type === 'docx' ||
                                        preview[2].type === 'xlsx' ||
                                        preview[2].type === 'image/jpeg' ||
                                        preview[2].type === 'image/png'
                                      "
                                      src="@/assets/images/ECU/icon-file.png"
                                      alt="icon-image"
                                      class="icon-file-upload"
                                    />
                                    <img
                                      v-else
                                      :src="preview[2].value"
                                      class="img-custom-preview"
                                    />
                                    </template>
                                    <p class="mb-0">
                                      file name: {{ image[2].name }}
                                    </p>
                                    <p class="mb-0">
                                      size: {{ image[2].size / 1024 }}KB
                                    </p>
                                  </div>
                                </template>
                              </div>
                            </div>
                            <template v-if="!isEdit">
                            <br />
                            <hr />
                            <br />
                            </template>
                            <div class="col-lg-4 mb-3">
                              <div class="form-group">
                                <label for="my-file3">Utility Bill</label>
                                <FileUploadField :name="docName('utility')" :busy="docBusy" @remove="removeDoc('utility')" @replace="onFileChange4"><input
                                  type="file"
                                  ref="fileInput5"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                                  @change="onFileChange4"
                                  class="form-control"
                                  id="my-file4"
                                /></FileUploadField>
                              </div>
                            </div>
                            <template v-if="isEdit">
                            <div class="col-lg-4">
                              <div class="form-group">
                                <label for="my-file2">Birth Certificate</label>
                                <FileUploadField :name="docName('birth_cert')" :busy="docBusy" @remove="removeDoc('birth_cert')" @replace="onFileChange5"><input
                                  type="file"
                                  ref="fileInput4"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                                  @change="onFileChange5"
                                  class="form-control"
                                  id="my-file2"
                                /></FileUploadField>
                              </div>
                            </div>
                            </template>
                            <template v-if="!isEdit">

                            <div
                              class="col-lg-4"
                              v-if="radioSelected1 === 'minor'"
                            >
                              <div class="form-group">
                                <label for="my-file2">Birth Certificate</label>
                                <FileUploadField :name="docName('birth_cert')" :busy="docBusy" @remove="removeDoc('birth_cert')" @replace="onFileChange5"><input
                                  type="file"
                                  ref="fileInput4"
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                                  @change="onFileChange5"
                                  class="form-control"
                                  id="my-file2"
                                /></FileUploadField>
                              </div>
                            </div>
                            </template>
<template v-if="!isEdit">

</template>
                            <div class="col-lg-4 mb-3">
                              <div class="form-group">
                                <template v-if="isEdit">
                                <label for="my-file9"
                                  >Pay Slip Or Job Letter</label
                                >
                                </template>
                                <template v-if="!isEdit">
                                <label for="my-file9"
                                  >Other's (Pay Slip Or Job Letter)</label
                                >
                                </template>
                                <template v-if="!isEdit">
                                <!-- Optional form input -->
                                </template>
                                <template v-if="isEdit">
                                <input
                                  type="file"
                                  ref="fileInput9"
                                  accept="image/*"
                                  @change="onFileChange9"
                                  class="form-control"
                                  id="my-file9"
                                />
                                </template>
                                <template v-if="!isEdit">
                                <input
                                  type="file"
                                  ref="fileInput9"
                                  multiple
                                  accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                                  @change="onFileChange9"
                                  class="form-control"
                                  id="my-file9"
                                />
                                </template>
                                <template v-if="!isEdit">

                                <div v-if="fileSizeError9" class="invalid-feedback">{{ fileSizeError9 }}</div>
                                </template>
                                <ul v-if="paySlipItems().length" class="list-unstyled mb-0 mt-2">
                                  <li
                                    v-for="item in paySlipItems()"
                                    :key="item.key"
                                    class="form-control d-flex align-items-center justify-content-between mb-1"
                                  >
                                    <span class="text-truncate me-2" :title="item.name">
                                      <i class="mdi mdi-file-outline me-1"></i>{{ item.name }}
                                    </span>
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-danger flex-shrink-0"
                                      :disabled="docBusy"
                                      @click="removeDoc('pay_slip', item)"
                                    >
                                      Remove
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";
import AppDatePicker from "@/components/shared/AppDatePicker.vue";
import FileUploadField from "@/components/shared/FileUploadField.vue";

export default {
  name: "PersonalInfoStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["errorpartone", "errorpart", "errorparttwo", "fileSizeError9", "radioSelected1", "invalidDOBMinor", "preview", "image", "docBusy", "nationalityOpt", "country_nameOpt", "titleNameOpt", "branchNameOpt", "countrynameIssuanceOpt", "nationalIssuanceOpt", "isInvalidDOB", "form", "invalidDOBadult", "ispassIssuenumberInvalid", "ispassnumberInvalid"],
    readonly: ["isIssueDateInvalid", "isExpiryDateInvalid", "isIssueDateFuture", "isdidIssueDateInvalid", "isdidExpiryDateInvalid", "isdidIssueDateFuture", "ispassIssueDateInvalid", "ispassExpiryDateInvalid", "ispassIssueDateFuture"],
    methods: ["validateZipCode", "validatehomenumber", "validatenationalidentification", "validatepassportnumber", "validatemobnumber", "validateDrivingIdNum", "onFileChange1", "onFileChange2", "onFileChange3", "onFileChange4", "onFileChange5", "onFileChange9", "docName", "paySlipItems", "removeDoc", "resetFields"],
    validate: true,
    }),
  ],
  components: { Select2, AppDatePicker, FileUploadField },
};
</script>

<style scoped>
/* A message that belongs to a whole row of fields (not one input) sits right
   under that row, exactly like the single-field messages do. The row above ends
   with a 1rem bottom margin, which is cancelled here and given back below. */
.ea-group-error {
  margin-top: -1rem;
  margin-bottom: 1rem;
}
</style>